import { render, staticRenderFns } from "./AppDetailsCmp.vue?vue&type=template&id=95d5cfd4&scoped=true&"
import script from "./AppDetailsCmp.vue?vue&type=script&lang=ts&"
export * from "./AppDetailsCmp.vue?vue&type=script&lang=ts&"
import style0 from "./AppDetailsCmp.vue?vue&type=style&index=0&id=95d5cfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d5cfd4",
  null
  
)

export default component.exports